import { ApiClient } from '@/shared/api-client';
import { ArgumentValidator } from './argument-validator';
import { ActivityType } from '../api-client/enums/activity-type';
import { QueryStringBuilder } from '../api-client/helpers/query-string-builder';

type FileArchiveEntityType = 'User' | 'AgendaItem';

export class Urls {

    public static electionCollection(id: string, copied = false): string {

        ArgumentValidator.notNullOrEmpty(id, `id`);

        return new QueryStringBuilder()
            .withQueryIfNotEmpty(`copied`, copied)
            .build(`/shell/electioncollectionmanager/edit/elections/${id}`);
    }

    public static candidacyElection(id: string, copied = false): string {

        ArgumentValidator.notNullOrEmpty(id, `id`);

        return new QueryStringBuilder()
            .withQueryIfNotEmpty(`copied`, copied)
            .build(`/shell/electionmanager/edit/elections/${id}`);
    }

    public static fileArchiveDownloadFile(fileArchiveId: string): string {

        ArgumentValidator.notNullOrEmpty(fileArchiveId, `fileArchiveId`);

        const split = fileArchiveId.split('/');

        if (split.length !== 5) {
            throw new Error(`Invalid file archive id`);
        }

        const entityType = split[1] as FileArchiveEntityType;
        const entityId = split[3];
        const fileId = split[4];

        return `${this.fileArchiveApiUrl}/file/${entityType}/${entityId}/${fileId}`;
    }

    private static get fileArchiveApiUrl(): string {

        const apiClient = new ApiClient();

        return `${apiClient.baseUrl}/fileArchive`;
    }

    public static activities(listType?: ActivityType, staleId?: string): string {

        return new QueryStringBuilder()
            .withQueryIfNotEmpty(`listType`, listType)
            .withQueryIfNotEmpty(`staleId`, staleId)
            .build(`/shell/activitymanager`);
    }

    public static activityMeeting(id: string): string {

        ArgumentValidator.notNullOrEmpty(id, `id`);

        return `/shell/activitymanager/meeting/${id}`;
    }

    public static activityMotioning(id: string): string {

        ArgumentValidator.notNullOrEmpty(id, `id`);

        return `/shell/activitymanager/motioning/${id}`;
    }

    public static activityMotion(activityId: string, id: string): string {

        ArgumentValidator.notNullOrEmpty(activityId, `activityId`);
        ArgumentValidator.notNullOrEmpty(id, `id`);

        return `/shell/activitymanager/motioning/${activityId}/${id}`;
    }

    public static error404(): string {

        return `/ErrorPages/404.aspx`;
    }
}
